import BasePage from "@Scripts/Pages/BasePage";

export default class ClassifiedPTWDetailPage extends BasePage {
    public static async init() {
        await super.init();

         this.setModal();
    }

    private static setModal() {
        let gallery = document.getElementById("lightGallery");
        if (gallery) {
            (<any>window).lightGallery(gallery, {
                selector: '.lg-item',
                download: false,
                thumbnail: true,
                loop: false
            });
        }
    }
}